<template>
  <div class="login">
    <img class="wave" src="@/assets/images/wave.png" alt />

    <div class="container">
      <div class="img">
        <img src="@/assets/images/img.svg" alt />
      </div>
      <div v-if="showloginform == false && showregisterform == false" class="login-container">
        <div class="book">
          <div class="workbook">
            <transition-group name="slide">
              <div v-if="book !== booksrandom.length" class="main" :key="book">
                <div class="question">
                  <span class="num">{{ booksrandom[book].id }}</span>
                  <span class="para">{{ booksrandom[book].question }}</span>
                  <span>( {{ booksrandom[book].limitedAnswer }}つ選択)</span>
                </div>
                <ul class="choice">
                  <li
                    v-for="(choice, index) in booksrandom[book].choice"
                    :key="index"
                    @click="getNum(index)"
                    :class="'selectedNum' + index"
                  >
                    <span v-if="index === 0" class="num">&#9312;</span>
                    <span v-if="index === 1" class="num">&#9313;</span>
                    <span v-if="index === 2" class="num">&#9314;</span>
                    <span v-if="index === 3" class="num">&#9315;</span>
                    <span v-if="index === 4" class="num">&#9316;</span>
                    <span v-if="index === 5" class="num">&#9317;</span>
                    <span v-if="index === 6" class="num">&#9318;</span>
                    <span v-if="index === 7" class="num">&#9319;</span>

                    <span class="para">
                      {{
                      booksrandom[book].choice[index].text
                      }}
                    </span>
                  </li>
                </ul>
                <div v-if="errorflag === true" class="errorCounter">
                  <span>回答数をご確認ください</span>
                </div>
                <div v-if="answerflag === true" class="answerCheck">
                  <span v-if="checkSelectedNum === currentlimitedAnswer" class="circle">&#9679;</span>
                  <span v-else class="cross">&#10005;</span>
                </div>
                <div v-if="answerflag === true" class="answer">
                  <p>正解</p>
                  <div v-for="(choice, index) in booksrandom[book].choice" :key="index">
                    <span
                      v-if="
                        index === 0 &&
                          booksrandom[book].choice[index].correct === true
                      "
                      class="correct"
                    >&#9312;</span>
                    <span
                      v-if="
                        index === 1 &&
                          booksrandom[book].choice[index].correct === true
                      "
                      class="correct"
                    >&#9313;</span>
                    <span
                      v-if="
                        index === 2 &&
                          booksrandom[book].choice[index].correct === true
                      "
                      class="correct"
                    >&#9314;</span>
                    <span
                      v-if="
                        index === 3 &&
                          booksrandom[book].choice[index].correct === true
                      "
                      class="correct"
                    >&#9315;</span>
                    <span
                      v-if="
                        index === 4 &&
                          booksrandom[book].choice[index].correct === true
                      "
                      class="correct"
                    >&#9316;</span>
                    <span
                      v-if="
                        index === 5 &&
                          booksrandom[book].choice[index].correct === true
                      "
                      class="correct"
                    >&#9317;</span>
                    <span
                      v-if="
                        index === 6 &&
                          booksrandom[book].choice[index].correct === true
                      "
                      class="correct"
                    >&#9318;</span>
                    <span
                      v-if="
                        index === 7 &&
                          booksrandom[book].choice[index].correct === true
                      "
                      class="correct"
                    >&#9319;</span>
                  </div>
                </div>
                <div v-if="answerflag === true" class="explanation">
                  <p>解説</p>
                  <span>{{ booksrandom[book].explanation }}</span>
                </div>
              </div>
            </transition-group>
          </div>
          <div v-if="checkAnswerflag === false" class="answerbtn" @click="checkAnswer()">回答を見る</div>
          <div v-if="checkAnswerflag === true" class="nextbtn" @click="next()">Next</div>
        </div>
      </div>
      <div v-else-if="showloginform == true && showregisterform == false" class="login-container">
        <div class="formdiv">
          <img class="avatar" src="@/assets/images/avatar.svg" alt />
          <h2>Welcome</h2>
          <h3>Let's Study AWS</h3>
          <h4>Solutions Architect - Associate</h4>
          <div class="input-div one">
            <div class="i">
              <img src="@/assets/images/user-solid.svg" alt />
            </div>
            <div>
              <input
                class="input"
                type="text"
                id="email"
                v-model="logininfo.email"
                placeholder="xxx@gmail.com"
                required
              />
            </div>
          </div>
          <div class="input-div">
            <div class="i">
              <img src="@/assets/images/lock-solid.svg" alt />
            </div>
            <div>
              <input
                class="input"
                type="text"
                id="pw"
                v-model="logininfo.pw"
                placeholder="xxxxxx"
                required
              />
            </div>
          </div>
          <a href="#" @click="changeRegisterForm()">Register</a>
          <!-- <a href="#">Forgot Password</a> -->
          <button class="btn" @click="tologin()">Login</button>
          <button class="btn example" @click="toexample()">Example</button>
          <div
            :class="{
              error: true,
              errorActive: errorLogin == true,
            }"
          >Email or PW is not corrected</div>
        </div>
      </div>
      <div v-else-if="showloginform == false && showregisterform == true" class="login-container">
        <div class="formdiv">
          <!-- <img class="avatar" src="@/assets/images/register.svg" alt=""> -->
          <h2>Register</h2>
          <h3>Let's Register</h3>
          <div class="input-div register">
            <div class="i">
              <label for="email">Email</label>
            </div>
            <div>
              <input
                class="input"
                type="text"
                id="email"
                v-model="registerinfo.email"
                placeholder="xxx@gmail.com"
                required
              />
            </div>
          </div>
          <div class="input-div register">
            <div class="i">
              <label for="pw">Password</label>
            </div>
            <div>
              <input
                class="input"
                type="text"
                id="pw"
                v-model="registerinfo.pw"
                placeholder="xxxxxx"
                required
              />
            </div>
          </div>
          <div class="input-div register">
            <div class="i">
              <label for="name">Name</label>
            </div>
            <div>
              <input
                class="input"
                type="text"
                id="name"
                v-model="registerinfo.name"
                placeholder="xxxxxx"
                required
              />
            </div>
          </div>
          <div class="input-div register">
            <div class="i">
              <label for="sex">sex</label>
            </div>
            <div class="inputRadio">
              <div>
                <span class="label">Man</span>
                <input
                  class="input"
                  type="radio"
                  id="sex"
                  v-model="registerinfo.sex"
                  placeholder="xxxxxx"
                  required
                  value="man"
                />
              </div>
              <div>
                <span class="label">Woman</span>
                <input
                  class="input"
                  type="radio"
                  id="sex"
                  v-model="registerinfo.sex"
                  placeholder="xxxxxx"
                  required
                  value="woman"
                />
              </div>
            </div>
          </div>
          <div class="input-div register">
            <div class="i">
              <label for="line">LINE</label>
            </div>
            <div>
              <input
                class="input"
                type="text"
                id="line"
                v-model="registerinfo.line"
                placeholder="xxxxxx"
                required
              />
            </div>
          </div>
          <div class="input-div register">
            <div class="i">
              <label for="address">Address</label>
            </div>
            <div>
              <select class="input" v-model="registerinfo.address">
                <option disabled value>Please select one</option>
                <option>北海道</option>
                <option>青森県</option>
                <option>岩手県</option>
                <option>宮城県</option>
                <option>秋田県</option>
                <option>山形県</option>
                <option>福島県</option>
                <option>茨城県</option>
                <option>栃木県</option>
                <option>群馬県</option>
                <option>埼玉県</option>
                <option>千葉県</option>
                <option>東京都</option>
                <option>神奈川県</option>
                <option>新潟県</option>
                <option>富山県</option>
                <option>石川県</option>
                <option>福井県</option>
                <option>山梨県</option>
                <option>長野県</option>
                <option>岐阜県</option>
                <option>静岡県</option>
                <option>愛知県</option>
                <option>三重県</option>
                <option>滋賀県</option>
                <option>京都府</option>
                <option>大阪府</option>
                <option>兵庫県</option>
                <option>奈良県</option>
                <option>和歌山県</option>
                <option>鳥取県</option>
                <option>島根県</option>
                <option>岡山県</option>
                <option>広島県</option>
                <option>山口県</option>
                <option>徳島県</option>
                <option>香川県</option>
                <option>愛媛県</option>
                <option>高知県</option>
                <option>福岡県</option>
                <option>佐賀県</option>
                <option>長崎県</option>
                <option>熊本県</option>
                <option>大分県</option>
                <option>宮崎県</option>
                <option>鹿児島県</option>
                <option>沖縄県</option>
              </select>
            </div>
          </div>
          <br />
          <p class="cautiontext">＊We will contact for sending the prizes to the Winners</p>
          <br />
          <a href="#" @click="changeLoginForm()">Login</a>
          <br />
          <button class="btn" @click="toregister()">Register</button>
          <div
            :class="{
              error: true,
              errorActive: errorRegister == true,
            }"
          >The input information is incorrect !</div>
          <div
            :class="{
              error: true,
              errorActive: errorAlreadyRegister == true,
            }"
          >The Address already exists !</div>
          <div
            :class="{
              error: true,
              successActive: successRegister == true,
            }"
          >Your registration is complete !</div>
        </div>
      </div>
      <div class="sponsor-container">
        <!-- 株式会社ねこ工房 -->
        <div>
          <a href="https://px.a8.net/svt/ejp?a8mat=3BHYIQ+F4RNAQ+46HI+64C3L" rel="nofollow">
            <img
              border="0"
              width="468"
              height="60"
              alt
              src="https://www24.a8.net/svt/bgt?aid=200712194915&wid=001&eno=01&mid=s00000019503001028000&mc=1"
            />
          </a>
          <img
            border="0"
            width="1"
            height="1"
            src="https://www12.a8.net/0.gif?a8mat=3BHYIQ+F4RNAQ+46HI+64C3L"
            alt
          />
        </div>
        <div>
          <!-- 株式会社ウィズペティ -->
          <a href="https://px.a8.net/svt/ejp?a8mat=3BHYIR+5CX82+3J9O+1TKWA9" rel="nofollow">
            <img
              border="0"
              width="120"
              height="60"
              alt
              src="https://www25.a8.net/svt/bgt?aid=200712195009&wid=001&eno=01&mid=s00000016494011015000&mc=1"
            />
          </a>
          <img
            border="0"
            width="1"
            height="1"
            src="https://www11.a8.net/0.gif?a8mat=3BHYIR+5CX82+3J9O+1TKWA9"
            alt
          />
        </div>
        <div>
          <!-- 株式会社ホーヴ -->
          <a href="https://px.a8.net/svt/ejp?a8mat=3BHYIR+10BGOI+4IMG+60OXD" rel="nofollow">
            <img
              border="0"
              width="120"
              height="60"
              alt
              src="https://www27.a8.net/svt/bgt?aid=200712195061&wid=001&eno=01&mid=s00000021076001011000&mc=1"
            />
          </a>
          <img
            border="0"
            width="1"
            height="1"
            src="https://www15.a8.net/0.gif?a8mat=3BHYIR+10BGOI+4IMG+60OXD"
            alt
          />
        </div>
        <div>
          <!-- グローバル商事株式会社 -->
          <a href="https://px.a8.net/svt/ejp?a8mat=3BI0VA+7QMVW2+4ICG+5Z6WX" rel="nofollow">
            <img
              border="0"
              width="468"
              height="60"
              alt
              src="https://www26.a8.net/svt/bgt?aid=200715238468&wid=001&eno=01&mid=s00000021040001004000&mc=1"
            />
          </a>
          <img
            border="0"
            width="1"
            height="1"
            src="https://www15.a8.net/0.gif?a8mat=3BI0VA+7QMVW2+4ICG+5Z6WX"
            alt
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import exampledata from "../src/assets/json/example.json";

export default {
  data() {
    return {
      errorLogin: false,
      errorRegister: false,
      errorAlreadyRegister: false,
      successRegister: false,
      showloginform: true,
      showregisterform: false,
      selectedNumArray: [],
      selectedNum0: false,
      selectedNum1: false,
      selectedNum2: false,
      selectedNum3: false,
      selectedNum4: false,
      selectedNum5: false,
      selectedNum6: false,
      selectedNum7: false,
      book: 0,
      books: exampledata,
      booksrandom: [],
      errorflag: false,
      answerflag: false,
      checkAnswerflag: false,
      checkSelectedNum: 0,
      currentlimitedAnswer: 0,
      logininfo: {
        email: "",
        pw: "",
      },
      registerinfo: {
        email: "",
        pw: "",
        name: "",
        sex: "",
        line: "",
        address: "",
        date: "",
      },
    };
  },
  created: function () {
    this.initialize();
  },
  methods: {
    changeLoginForm() {
      this.initializeErrorSucMsg();
      this.showloginform = true;
      this.showregisterform = false;
    },
    changeRegisterForm() {
      this.initializeErrorSucMsg();
      this.showloginform = false;
      this.showregisterform = true;
    },
    initialize() {
      this.selectedNumArray.length = 0;
      this.selectedNum0 = false;
      this.selectedNum1 = false;
      this.selectedNum2 = false;
      this.selectedNum3 = false;
      this.selectedNum4 = false;
      this.selectedNum5 = false;
      this.selectedNum6 = false;
      this.selectedNum7 = false;

      this.errorflag = false;
      this.answerflag = false;
      this.checkAnswerflag = false;
      this.booksrandom = this.shuffle(this.books);
      this.checkSelectedNum = 0;
    },
    initializeClass() {
      if (document.querySelector(".selectedNum0")) {
        document.querySelector(".selectedNum0").classList.remove("active");
        document.querySelector(".selectedNum0").classList.remove("eventsNone");
      }
      if (document.querySelector(".selectedNum1")) {
        document.querySelector(".selectedNum1").classList.remove("active");
        document.querySelector(".selectedNum1").classList.remove("eventsNone");
      }
      if (document.querySelector(".selectedNum2")) {
        document.querySelector(".selectedNum2").classList.remove("active");
        document.querySelector(".selectedNum2").classList.remove("eventsNone");
      }
      if (document.querySelector(".selectedNum3")) {
        document.querySelector(".selectedNum3").classList.remove("active");
        document.querySelector(".selectedNum3").classList.remove("eventsNone");
      }
      if (document.querySelector(".selectedNum4")) {
        document.querySelector(".selectedNum4").classList.remove("active");
        document.querySelector(".selectedNum4").classList.remove("eventsNone");
      }
      if (document.querySelector(".selectedNum5")) {
        document.querySelector(".selectedNum5").classList.remove("active");
        document.querySelector(".selectedNum5").classList.remove("eventsNone");
      }
      if (document.querySelector(".selectedNum6")) {
        document.querySelector(".selectedNum6").classList.remove("active");
        document.querySelector(".selectedNum6").classList.remove("eventsNone");
      }
      if (document.querySelector(".selectedNum7")) {
        document.querySelector(".selectedNum7").classList.remove("active");
        document.querySelector(".selectedNum7").classList.remove("eventsNone");
      }
    },
    shuffle(array) {
      for (let i = 0; i < array.length; i++) {
        for (let j = 0; j < array[i].choice.length; j++) {
          let r = Math.floor(Math.random() * (j + 1));
          let tmp = array[i].choice[j];
          array[i].choice[j] = array[i].choice[r];
          array[i].choice[r] = tmp;
        }
      }
      return array;
    },
    initializeErrorSucMsg() {
      this.errorLogin = false;
      this.errorRegister = false;
      this.errorAlreadyRegister = false;
      this.successRegister = false;

      //login value
      this.logininfo.email = "";
      this.logininfo.pw = "";

      //register value
      this.registerinfo.email = "";
      this.registerinfo.pw = "";
      this.registerinfo.name = "";
      this.registerinfo.sex = "";
      this.registerinfo.line = "";
      this.registerinfo.address = "";
    },
    tologin() {
      let formData = new FormData();
      formData.append("logininfo", JSON.stringify(this.logininfo));

      //テスト
      // axios
      //   .post("http://localhost/login.php", formData)
      //本番
      axios
        .post("/php/login.php", formData)
        .then((res) => {
          // console.log(res.data[0])
          if (res.data.length == 1) {
            // console.log('ログイン成功')
            this.errorLogin = false;

            //cookie設定
            this.$cookie.set("awsexhome", "success aws exercise", {
              expires: "1D",
            });
            // 1Y
            // 1M
            // 1D
            // 1h
            // 10m
            // 30s

            //homeページへ
            this.$router.push("/home");
          } else {
            // console.log('ログイン失敗')
            this.errorLogin = true;
          }
        })
        .catch(() => {
          // console.log(err)
          this.$Message.error({
            content: "Ajax Error",
            duration: 0,
            closable: true,
          });
        });
    },
    toexample() {
      this.showloginform = false;
    },
    toregister() {
      let formData = new FormData();
      formData.append("registerinfo", JSON.stringify(this.registerinfo));

      //テスト
      // axios
      //   .post("http://localhost/checkemail.php", formData)
      //本番
      axios
        .post("/php/checkemail.php", formData)
        .then((res) => {
          // console.log(res.data[0])
          if (res.data.length <= 0) {
            let infocheckflg = true;

            //emailチェック
            let reg = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/;
            if (!reg.test(this.registerinfo.email)) {
              infocheckflg = false;
            }

            //pwチェック
            if (!this.registerinfo.pw) {
              infocheckflg = false;
            }
            //nameチェック
            if (!this.registerinfo.name) {
              infocheckflg = false;
            }
            //sexチェック
            if (!this.registerinfo.sex) {
              infocheckflg = false;
            }
            //lineチェック
            if (!this.registerinfo.line) {
              infocheckflg = false;
            }
            //addressチェック
            if (!this.registerinfo.address) {
              infocheckflg = false;
            }

            if (infocheckflg) {
              //時刻設定
              let youbi = ["日", "月", "火", "水", "木", "金", "土"];
              let date1 = new Date();
              let date2 =
                date1.getFullYear() +
                "." +
                (date1.getMonth() + 1) +
                "." +
                date1.getDate() +
                ", " +
                date1.getHours() +
                ":" +
                date1.getMinutes() +
                ":" +
                date1.getSeconds() +
                ", " +
                youbi[date1.getDay()] +
                "曜日";
              this.registerinfo.date = date2;

              let formData = new FormData();
              formData.append(
                "registerinfo",
                JSON.stringify(this.registerinfo)
              );

              //テスト
              // axios
              //   .post("http://localhost/create.php", formData)
              //本番
              axios
                .post("/php/create.php", formData)
                .then(() => {
                  // console.log(res)
                  this.errorRegister = false;
                  this.errorAlreadyRegister = false;
                  this.successRegister = true;
                })
                .catch(() => {
                  // console.log(err)
                  this.$Message.error({
                    content: "Ajax Error",
                    duration: 0,
                    closable: true,
                  });
                });
            } else {
              this.errorRegister = true;
            }
          } else {
            this.errorRegister = false;
            this.errorAlreadyRegister = true;
          }
        })
        .catch(() => {
          // console.log(err)
          this.$Message.error({
            content: "Ajax Error",
            duration: 0,
            closable: true,
          });
        });
    },

    getNum(num) {
      if (num === 0) {
        this.selectedNum0 = !this.selectedNum0;
        this.selectedNum0 === true
          ? document.querySelector(".selectedNum0").classList.add("active")
          : document.querySelector(".selectedNum0").classList.remove("active");
      }
      if (num === 1) {
        this.selectedNum1 = !this.selectedNum1;
        this.selectedNum1 === true
          ? document.querySelector(".selectedNum1").classList.add("active")
          : document.querySelector(".selectedNum1").classList.remove("active");
      }
      if (num === 2) {
        this.selectedNum2 = !this.selectedNum2;
        this.selectedNum2 === true
          ? document.querySelector(".selectedNum2").classList.add("active")
          : document.querySelector(".selectedNum2").classList.remove("active");
      }
      if (num === 3) {
        this.selectedNum3 = !this.selectedNum3;
        this.selectedNum3 === true
          ? document.querySelector(".selectedNum3").classList.add("active")
          : document.querySelector(".selectedNum3").classList.remove("active");
      }
      if (num === 4) {
        this.selectedNum4 = !this.selectedNum4;
        this.selectedNum4 === true
          ? document.querySelector(".selectedNum4").classList.add("active")
          : document.querySelector(".selectedNum4").classList.remove("active");
      }
      if (num === 5) {
        this.selectedNum5 = !this.selectedNum5;
        this.selectedNum5 === true
          ? document.querySelector(".selectedNum5").classList.add("active")
          : document.querySelector(".selectedNum5").classList.remove("active");
      }
      if (num === 6) {
        this.selectedNum6 = !this.selectedNum6;
        this.selectedNum6 === true
          ? document.querySelector(".selectedNum6").classList.add("active")
          : document.querySelector(".selectedNum6").classList.remove("active");
      }
      if (num === 7) {
        this.selectedNum7 = !this.selectedNum7;
        this.selectedNum7 === true
          ? document.querySelector(".selectedNum7").classList.add("active")
          : document.querySelector(".selectedNum7").classList.remove("active");
      }

      if (this.selectedNumArray.indexOf(num) < 0) {
        // 追加
        this.selectedNumArray.push(num);
      } else {
        // 削除
        this.selectedNumArray.splice(this.selectedNumArray.indexOf(num), 1);
      }
    },

    checkAnswer() {
      this.currentlimitedAnswer = this.booksrandom[this.book].limitedAnswer;
      if (
        this.selectedNumArray.length !==
        this.booksrandom[this.book].limitedAnswer
      ) {
        this.errorflag = true;
      } else {
        this.errorflag = false;
        this.answerflag = true;
        this.checkAnswerflag = true;

        if (document.querySelector(".selectedNum0"))
          document.querySelector(".selectedNum0").classList.add("eventsNone");
        if (document.querySelector(".selectedNum1"))
          document.querySelector(".selectedNum1").classList.add("eventsNone");
        if (document.querySelector(".selectedNum2"))
          document.querySelector(".selectedNum2").classList.add("eventsNone");
        if (document.querySelector(".selectedNum3"))
          document.querySelector(".selectedNum3").classList.add("eventsNone");
        if (document.querySelector(".selectedNum4"))
          document.querySelector(".selectedNum4").classList.add("eventsNone");
        if (document.querySelector(".selectedNum5"))
          document.querySelector(".selectedNum5").classList.add("eventsNone");
        if (document.querySelector(".selectedNum6"))
          document.querySelector(".selectedNum6").classList.add("eventsNone");
        if (document.querySelector(".selectedNum7"))
          document.querySelector(".selectedNum7").classList.add("eventsNone");

        for (let i = 0; i < this.selectedNumArray.length; i++) {
          for (let j = 0; j < this.booksrandom[this.book].choice.length; j++) {
            if (this.booksrandom[this.book].choice[j].correct === true) {
              if (j == this.selectedNumArray[i]) {
                this.checkSelectedNum++;
              }
            }
          }
        }
      }
    },

    next() {
      this.book = this.book < this.booksrandom.length ? (this.book += 1) : 0;

      if (this.book !== this.booksrandom.length) {
        this.initializeClass();
        this.initialize();
      } else {
        this.showloginform = true;
        this.book = 0;
        this.initializeClass();
        this.initialize();
        this.initializeErrorSucMsg();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wave {
  position: fixed;
  height: 100%;
  left: 0;
  bottom: 0;
  z-index: -1;
}

.container {
  width: 100vw;
  height: 100vh;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 7rem;
  padding: 0 2rem;
}

.img {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  img {
    width: 500px;
  }
}

.login-container {
  display: flex;
  align-items: center;
  text-align: center;
}

.sponsor-container {
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
}

.formdiv {
  margin-top: 25px;
  width: 360px;
  min-height: 532px;
  .avatar {
    width: 100px;
  }
  h2 {
    font-size: 2.9rem;
    text-transform: uppercase;
    margin: 15px 0;
    color: #333;
  }
  .input-div {
    position: relative;
    display: grid;
    grid-template-columns: 15% 85%;
    margin: 25px 0;
    padding: 5px 0;
    border-bottom: 2px solid #d9d9d9;
    margin-bottom: 4px;
    &.register {
      grid-template-columns: 23% 77%;
      .inputRadio {
        display: flex;
        justify-content: space-around;
        align-items: center;
        .label {
          margin-right: 10px;
          color: rgb(138, 138, 138);
        }
        input {
          position: static;
          width: auto;
          height: auto;
        }
      }
    }
    &::after,
    &::before {
      content: "";
      position: absolute;
      bottom: -2px;
      width: 0;
      height: 2px;
      background-color: #38d39f;
    }
    &:after {
      right: 50%;
    }
    &:before {
      left: 50%;
    }

    & > div {
      position: relative;
      height: 45px;
    }

    .i {
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 30px;
      }
    }

    .input {
      position: absolute;
      top: 0;
      left: 0;
      border: none;
      outline: none;
      background: none;
      padding: 0.5rem 0.7rem;
      font-size: 1.2rem;
      font-family: "Poppins", sans-serif;
      color: #555;
      width: 100%;
      height: 100%;
      &::placeholder {
        color: rgb(169, 169, 169);
      }
    }
  }
}

a {
  display: block;
  text-align: right;
  text-decoration: none;
  color: #999;
  font-size: 0.9rem;
  transition: 0.3s;
  &:hover {
    color: #38d39f;
    cursor: pointer;
  }
}

.btn {
  display: block;
  width: 100%;
  height: 35px;
  border-radius: 25px;
  margin: 1rem 0;
  outline: none;
  border: none;
  font-size: 1rem;
  background-image: linear-gradient(to right, #32be8f, #38d39f, #32be8f);
  color: #fff;
  text-transform: uppercase;
  font-family: "Poppins", sans-serif;
  background-size: 200%;
  transition: 0.5s;
  &:hover {
    background-position: right;
    cursor: pointer;
  }
  &.example {
    background-image: linear-gradient(to right, #386bb6, #2f82ff, #386bb6);
  }
}

.book {
  width: 100%;
  margin-top: 25px;
  .workbook {
    position: relative;
    width: 100%;
    min-height: 532px;
    overflow-x: hidden;
    -ms-overflow-style: none; /* IE, Edge 対応 */
    scrollbar-width: none; /* Firefox 対応 */
    &::-webkit-scrollbar {
      /* Chrome, Safari 対応 */
      display: none;
    }
    .main {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      border: 1px solid #38d39f;
      border-radius: 5px;
      background-color: #fff;
      text-align: initial;
      padding: 10px;
      .question {
        margin-bottom: 20px;
        padding-bottom: 10px;
        border-bottom: 1px solid #38d39f;
        .num {
          font-weight: bold;
          font-size: 26px;
          color: #38d39f;
          margin-right: 10px;
        }
        .para {
          white-space: pre-wrap;
        }
      }
      .choice {
        li {
          list-style: none;
          padding: 10px;
          margin-bottom: 10px;
          &:hover {
            cursor: pointer;
            opacity: 0.6;
          }
          &.active {
            background-color: #fafa84;
          }
          &.eventsNone {
            pointer-events: none;
          }
          .num {
            display: inline-block;
            width: 30px;
          }
          .para {
            white-space: pre-wrap;
          }
        }
      }
      .errorCounter {
        text-align: center;
        color: #f06060;
        font-weight: bold;
        letter-spacing: 2px;
      }
      .answerCheck {
        border-top: 1px solid #38d39f;
        padding: 10px;
        text-align: center;
        font-size: 25px;
        .circle {
          color: #67a5eb;
        }
        .cross {
          color: #f06060;
        }
      }
      .answer {
        border-top: 1px solid #38d39f;
        padding: 10px;
        & > div {
          display: inline;
        }
        .correct {
          color: rgb(223, 37, 37);
        }
        p {
          font-weight: bold;
        }
      }
      .explanation {
        padding: 10px;
        border-top: 1px solid #38d39f;
        color: #000;
        font-size: 15px;
        p {
          font-weight: bold;
        }
      }
    }
  }
  .answerbtn,
  .nextbtn {
    margin-top: 10px;
    border-radius: 5px;
    padding: 5px;
    width: 100%;
    color: #fff;
    &:hover {
      cursor: pointer;
      opacity: 0.6;
    }
  }
  .answerbtn {
    background-color: #03a38e;
  }
  .nextbtn {
    background-color: #3f4fda;
  }
}

.error {
  display: none;
  color: rgb(223, 37, 37);
  &.errorActive {
    display: block;
  }
  &.successActive {
    display: block;
    color: #03a38e;
  }
}

.cautiontext {
  color: #03a358;
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.4s;
}
.slide-enter {
  transform: translateX(400px);
}
.slide-leave-active {
  transform: translateX(-400px);
}

@media screen and (max-width: 1050px) {
  .container {
    grid-gap: 1rem;
  }
  .sponsor-container {
    img:first-child {
      background-color: red;
      width: 100%;
      height: auto;
    }
  }
}
@media screen and (max-width: 1000px) {
  .formdiv {
    width: 290px;
    h2 {
      font-size: 2.4rem;
      margin: 8px 0;
    }
  }

  .img {
    img {
      width: 400px;
    }
  }
}
@media screen and (max-width: 900px) {
  .img {
    display: none;
  }

  .container {
    grid-template-columns: 1fr;
  }

  .wave {
    display: none;
  }

  .login-container {
    justify-content: center;
  }
}
</style>
